module.exports = __webpack_public_path__ + "img/leftMan.a70abdd0.png";